module.exports = __webpack_public_path__ + "assets/lucky-wheel-small-icon-3fa898.png";